/* tslint:disable */
/* eslint-disable */
/**
 * Finastic Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckRegistrationOtpCommand
 */
export interface CheckRegistrationOtpCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckRegistrationOtpCommand
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CheckRegistrationOtpCommand
     */
    otp: string;
}

export function CheckRegistrationOtpCommandFromJSON(json: any): CheckRegistrationOtpCommand {
    return CheckRegistrationOtpCommandFromJSONTyped(json, false);
}

export function CheckRegistrationOtpCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckRegistrationOtpCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phoneNumber': json['phoneNumber'],
        'otp': json['otp'],
    };
}

export function CheckRegistrationOtpCommandToJSON(value?: CheckRegistrationOtpCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phoneNumber': value.phoneNumber,
        'otp': value.otp,
    };
}

